import { IS_RECORDING, STOP_RECORDING, SHOW_ACCOUNT_VERIFY, HIDE_ACCOUNT_VERIFY, TOGGLE_RECORDING, SET_RECORDING_TIME } from "../actions/note.action";

const INITIAL_STATE = {
   isRecording: false,
   showVerifyAccount: false,
   errorRecording: false,
   recordTime: "00:00"
};

export default function Notes(state = INITIAL_STATE, action) {
   switch (action.type) {
      case SHOW_ACCOUNT_VERIFY:
         return {
            ...state,
            showVerifyAccount: true,
         };
      case HIDE_ACCOUNT_VERIFY:
         return {
            ...state,
            showVerifyAccount: false,
         };
      case IS_RECORDING:
         return {
            ...state,
            isRecording: !state.isRecording,
         };
      case STOP_RECORDING:
         return {
            ...state,
            isRecording: false,
         };
      case TOGGLE_RECORDING:
         return {
            ...state,
            errorRecording: action.payload,
         };
      case SET_RECORDING_TIME:
         return {
            ...state,
            recordTime: action.payload,
         };
      default:
         return state;
   }
}
